import axios from "axios";
import jsPDF from "jspdf";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Back from "../components/button/back";
import JumlahNilai from "./JumlahNilai";
import KURKUMlist from "./KURKUMlist2";
import NilaiRaporList from "./NilaiRaporList";
import Persen from "./Persen";
import TabelPersen from "./TabelPersen";

const ElearningGuru = () => {
  const { mapel } = useParams();
  const [questions, setQuestions] = useState([]);
  const [semester, setSemester] = useState("1");
  const [isEditing, setIsEditing] = useState(false);
  const [user, setUser] = useState(null);
  const [filterKelas, setFilterKelas] = useState("");
  const [filterRombel, setFilterRombel] = useState("");

  // const [dataId, setDataId] = useState([]);
  // const [selectedIds, setSelectedIds] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const userId = decoded.user.id;

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/questions/mapel/${mapel}/user/${userId}?semester=${semester}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // setDataId(idOnly);
        setQuestions(response.data);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    if (mapel) {
      fetchQuestions();
    }
  }, [mapel, semester]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/auth/profile`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        setUser(res.data);
        setFilterKelas(res.data?.kelas || "");
        setFilterRombel(res.data?.rombel || "");
      } catch (err) {
        console.error("Gagal mengambil profile", err);
      }
    };

    fetchProfile();
  }, []);

  const imageUrlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handleDownloadSoalPDF = async (soal) => {
    if (!soal?.question || soal.question.length === 0) {
      alert("Soal kosong");
      return;
    }

    const pdf = new jsPDF("p", "mm", "a4");
    let y = 20;
    let nomor = 1;

    /* ================= KOP ================= */
    pdf.setFontSize(14);
    pdf.text("SOAL UJIAN", 105, y, { align: "center" });

    y += 8;
    pdf.setFontSize(10);
    pdf.text(`Mata Pelajaran : ${soal.mapel}`, 20, y);
    pdf.text(`Kelas : ${soal.kelas}${soal.rombel}`, 120, y);

    y += 6;
    pdf.text(`Semester : ${soal.semester}`, 20, y);
    pdf.text(`Jenis : ${soal.jenis}`, 120, y);

    y += 6;
    pdf.line(20, y, 190, y);
    y += 10;

    /* ================= LOOP SOAL ================= */
    for (const q of soal.question) {
      pdf.setFontSize(11);

      /* ===== TEXT SOAL ===== */
      const soalText = `${nomor}. ${q.text || ""}`;
      const soalLines = pdf.splitTextToSize(soalText, 165);
      pdf.text(soalLines, 20, y);
      y += soalLines.length * 6;

      /* ===== GAMBAR SOAL ===== */
      if (q.gambar?.filename) {
        const img64 = await imageUrlToBase64(
          `${process.env.REACT_APP_API_URL}api/questions/image/${q.gambar.filename}`,
        );

        pdf.addImage(img64, "JPEG", 25, y, 70, 45);
        y += 50;
      }

      /* ===== PILIHAN GANDA (TEKS + GAMBAR) ===== */
      if (q.type === "multipleChoice") {
        const col1X = 30;
        const col2X = 110;
        let optionY = y;

        for (let i = 0; i < q.options.length; i++) {
          const opt = q.options[i];
          const label = String.fromCharCode(97 + i);
          const text = `${label}. ${opt.text || ""}`;

          const x = i % 2 === 0 ? col1X : col2X;
          let yPos = optionY;

          // TEXT OPTION
          const textLines = pdf.splitTextToSize(text, 65);
          pdf.text(textLines, x, yPos);
          yPos += textLines.length * 5;

          // GAMBAR OPTION
          if (opt.gambar?.filename) {
            const img64 = await imageUrlToBase64(
              `${process.env.REACT_APP_API_URL}api/questions/image/${opt.gambar.filename}`,
            );

            pdf.addImage(img64, "JPEG", x, yPos, 45, 30);
            yPos += 35;
          }

          // Pindah baris setelah 2 kolom
          if (i % 2 === 1) {
            optionY = Math.max(optionY, yPos) + 5;
          }
        }

        y = optionY + 5;
      }

      /* ===== ESSAY ===== */
      if (q.type === "essay") {
        pdf.text("Jawaban:", 30, y);
        y += 6;
        for (let i = 0; i < 3; i++) {
          pdf.line(30, y, 180, y);
          y += 8;
        }
      }

      nomor++;
      y += 8;

      /* ===== PAGE BREAK ===== */
      if (y > 270) {
        pdf.addPage();
        y = 20;
      }
    }

    /* ================= SAVE ================= */
    pdf.save(
      `Soal-${soal.mapel}-Kelas${soal.kelas}${soal.rombel}-Semester${soal.semester}.pdf`,
    );
  };

  const handleToggle = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}api/questions/${id}/toggleStatus`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setQuestions((prevQuestions) =>
        prevQuestions.map((question) =>
          question._id === id
            ? { ...question, status: response.data.status }
            : question,
        ),
      );
    } catch (error) {
      console.error("Error toggling question status:", error);
    }
  };

  const handleExportSingleSoal = (id) => {
    const soal = questions.find((q) => q._id === id);
    if (!soal) return alert("Soal tidak ditemukan!");

    const { _id, createdBy, __v, ...cleanedSoal } = soal; // Hapus field sensitif

    const json = JSON.stringify(cleanedSoal, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `soal-${cleanedSoal.jenis}-kelas${cleanedSoal.kelas}${cleanedSoal.rombel}-semester${cleanedSoal.semester}.json`;
    link.click();

    URL.revokeObjectURL(url);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const jsonData = JSON.parse(event.target.result);

        // Kosongkan _id dan createdBy jika ada
        if (jsonData._id) delete jsonData._id;
        if (jsonData.createdBy) delete jsonData.createdBy;

        localStorage.setItem("soalUpload", JSON.stringify(jsonData));
        navigate("/guru/addquestion"); // Ganti dengan path formulirmu
      } catch (error) {
        console.error("Error parsing JSON:", error);
        alert("Format JSON tidak valid!");
      }
    };

    reader.readAsText(file);
  };

  const handleDelete = async (questionId) => {
    const soal = questions.find((q) => q._id === questionId);
    if (!soal) return;

    const { jenis, kelas, rombel, semester, mapel } = soal;
    const tahun = new Date().getFullYear(); // ganti jika kamu punya sumber tahun lain

    const confirmDelete = window.confirm(
      `Anda akan menghapus paket soal:\n\n- Mata Pelajaran: ${mapel}\n- Jenis: ${jenis}\n- Kelas: ${kelas}${rombel}\n- Semester: ${semester}\n\nApakah Anda yakin ingin melanjutkan?`,
    );

    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const userId = decoded.user.id;

      const headers = { Authorization: `Bearer ${token}` };

      // 1. Hapus soal
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/questions/${questionId}`,
        { headers },
      );

      // 2. Hapus nilai jika ada
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}api/nilai/mapel/${mapel}/question/${questionId}/kelas/${kelas}/rombel/${rombel}/tahun/${tahun}/semester/${semester}/jenis/${jenis}`,
          { headers },
        );
      } catch (err) {
        if (err.response?.status === 404) {
        } else {
          console.warn("Gagal menghapus nilai:", err.message);
        }
      }

      // 3. Hapus semua jawaban dari user terkait
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}api/answers/question/${questionId}`,
          { headers },
        );
      } catch (err) {
        if (err.response?.status === 404) {
        } else {
          console.warn("Gagal menghapus jawaban:", err.message);
        }
      }

      // 4. Update tampilan UI
      setQuestions((prev) => prev.filter((q) => q._id !== questionId));

      alert("Soal, nilai, dan jawaban berhasil dihapus (jika ada).");
    } catch (error) {
      console.error("Gagal menghapus soal:", error);
      alert("Gagal menghapus soal. Silakan coba lagi.");
    }
  };

  const handleSemesterChange = (e) => {
    setSemester(e.target.value);
  };

  return (
    <div className="grid justify-center min-h-screen bg-blue-100">
      <div className="w-[400px] sm:w-auto">
        <div className="flex justify-center items-center mt-10">
          <h2 className="font-bold text-3xl">Mata Pelajaran {mapel}</h2>
        </div>
        <div className="bg-white mx-10 mt-5 rounded-lg drop-shadow-lg py-5">
          <div className="mt-6 flex justify-center">
            <div
              className="
      w-full max-w-4xl
      bg-white rounded-xl
      shadow-md
      p-4 sm:p-6
      space-y-4
    "
            >
              {/* ================= FILTER SEMESTER ================= */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1 text-gray-700">
                  Semester
                </label>
                <select
                  value={semester}
                  onChange={(e) => setSemester(e.target.value)}
                  className="
          border rounded-lg
          px-3 py-2
          focus:outline-none focus:ring-2 focus:ring-blue-400
        "
                >
                  <option value="">Pilih Semester</option>
                  <option value="1">Semester 1</option>
                  <option value="2">Semester 2</option>
                </select>
              </div>

              {/* ================= FILTER KELAS & ROMBEL ================= */}
              {user?.jabatan === "Guru Mapel" && (
                <div
                  className="
          grid grid-cols-1
          sm:grid-cols-2
          gap-4
        "
                >
                  {/* KELAS */}
                  <div className="flex flex-col">
                    <label className="text-sm font-semibold mb-1 text-gray-700">
                      Kelas
                    </label>
                    <select
                      value={filterKelas}
                      onChange={(e) => setFilterKelas(e.target.value)}
                      className="
              border rounded-lg
              px-3 py-2
              focus:outline-none focus:ring-2 focus:ring-blue-400
            "
                    >
                      <option value="">Semua</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                    </select>
                  </div>

                  {/* ROMBEL */}
                  <div className="flex flex-col">
                    <label className="text-sm font-semibold mb-1 text-gray-700">
                      Rombel
                    </label>
                    <select
                      value={filterRombel}
                      onChange={(e) => setFilterRombel(e.target.value)}
                      className="
              border rounded-lg
              px-3 py-2
              focus:outline-none focus:ring-2 focus:ring-blue-400
            "
                    >
                      <option value="">Semua</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center items-center">
            <div className="grid lg:grid-cols-3 lg:gap-5 gap-4">
              {questions
                .filter((question) => {
                  // semester selalu difilter
                  if (question.semester !== semester) return false;

                  // filter kelas & rombel HANYA jika Guru Mapel
                  if (user?.jabatan === "Guru Mapel") {
                    if (filterKelas && question.kelas !== filterKelas)
                      return false;
                    if (filterRombel && question.rombel !== filterRombel)
                      return false;
                  }

                  return true;
                })
                .map((question) => (
                  <div
                    key={question._id}
                    className="mt-6 w-full flex justify-center"
                  >
                    <div
                      className="
      w-full max-w-sm sm:max-w-md md:max-w-lg
      bg-gradient-to-br from-blue-200 to-blue-300
      rounded-2xl
      p-5
      shadow-lg hover:shadow-xl
      transition-all duration-300
    "
                    >
                      {/* ===== JENIS UJIAN ===== */}
                      <h2 className="text-center font-bold text-lg sm:text-xl mb-2">
                        {question.jenis === "STS"
                          ? "Sumatif Tengah Semester"
                          : question.jenis === "SAS"
                            ? "Sumatif Akhir Semester"
                            : question.jenis}
                      </h2>

                      {/* ===== KELAS ===== */}
                      <p className="text-center text-base sm:text-lg font-semibold mb-4">
                        Kelas {question.kelas}
                        {question.rombel}
                      </p>

                      {/* ===== ACTION UTAMA ===== */}
                      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
                        <button
                          onClick={() => handleToggle(question._id)}
                          className="
          bg-blue-500 hover:bg-blue-600
          text-white text-sm font-semibold
          py-2 rounded-lg
          transition
        "
                        >
                          {question.status ? "Tutup" : "Buka"}
                        </button>

                        <Link
                          to={`/guru/elearning-guru/${mapel}/edit/${question._id}`}
                          className="
          bg-green-500 hover:bg-green-600
          text-white text-sm font-semibold
          py-2 rounded-lg
          flex items-center justify-center
          transition
        "
                        >
                          Edit
                        </Link>

                        <button
                          onClick={() => handleDelete(question._id)}
                          className="
          bg-red-500 hover:bg-red-600
          text-white text-sm font-semibold
          py-2 rounded-lg
          transition
        "
                        >
                          Hapus
                        </button>

                        <Link
                          to={`/guru/elearning-guru/${mapel}/nilai/${question._id}`}
                          className="
          bg-emerald-500 hover:bg-emerald-600
          text-white text-sm font-semibold
          py-2 rounded-lg
          flex items-center justify-center
          transition
        "
                        >
                          Nilai
                        </Link>
                      </div>

                      {/* ===== DOWNLOAD ===== */}
                      <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <button
                          onClick={() => handleExportSingleSoal(question._id)}
                          className="
          flex items-center justify-center gap-2
          bg-green-600 hover:bg-green-700
          text-white text-sm font-semibold
          px-4 py-2 rounded-lg
          shadow-md hover:shadow-lg
          transition
        "
                        >
                          📥 Download Soal
                        </button>

                        <button
                          onClick={() => handleDownloadSoalPDF(question)}
                          className="
          flex items-center justify-center gap-2
          bg-purple-600 hover:bg-purple-700
          text-white text-sm font-semibold
          px-4 py-2 rounded-lg
          shadow-md hover:shadow-lg
          transition
        "
                        >
                          📄 Download PDF
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="mt-10 flex justify-center gap-2">
          <Link to="/guru/addquestion">
            <button className="bg-red-400 px-5 py-3 rounded-xl">
              Tambah soal
            </button>
          </Link>
          <label className="bg-yellow-500 hover:bg-yellow-600 text-white px-5 py-3 rounded-xl cursor-pointer">
            Upload Soal
            <input
              type="file"
              accept="application/json"
              className="hidden"
              onChange={handleFileUpload}
            />
          </label>
        </div>

        <div>
          <Persen mapel={mapel} onEdit={() => setIsEditing(true)} />
          {isEditing && (
            <TabelPersen mapel={mapel} onSubmit={() => setIsEditing(false)} />
          )}

          <JumlahNilai mapel={mapel} />
          <KURKUMlist mapel={mapel} />
          {/* <TujuanPembelajran mapel={mapel} /> */}
          <NilaiRaporList mapel={mapel} />
        </div>
        <div className="flex justify-center mt-20">
          <Link to={"/guru"}>
            <Back />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ElearningGuru;
